import {
  IonList,
  IonListHeader,
} from '@ionic/react';
import React, { useRef, useEffect } from 'react';
import { Shipment } from '../models/Shipment';
import ShipmentListItem from './ShipmentListItem';

interface OwnProps {
  shipments: Shipment[];
}

interface StateProps {
}

interface ShipmentListProps extends OwnProps, StateProps {}

const ShipmentList: React.FC<ShipmentListProps> = ({
  shipments,
}) => {
  const shipmentListRef = useRef<HTMLIonListElement>(null);

  useEffect(() => {
    if (shipmentListRef.current) {
      shipmentListRef.current.closeSlidingItems();
    }
  }, []);

  if (shipments.length === 0) {
    return (
      <IonList>
        <IonListHeader>データがありません。</IonListHeader>
      </IonList>
    );
  }

  return (
    <>
      <IonList ref={shipmentListRef}>
        {shipments.map((record, index: number) => (
          <ShipmentListItem
            key={`record-${index}`}
            shipment={record}
          />
        ))}
      </IonList>
    </>
  );
};

export default ShipmentList;
